import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import * as Sentry from '@sentry/react'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'
import './styles/index.css'
import Big from 'big.js'

const ENV = process.env.REACT_APP_ENV ?? 'development'
const isLocal = ENV === 'development'

if (ENV !== 'development') {
  Sentry.init({
    dsn: 'https://9f793b1ac40bcd5fa4de2497d42ab441@o4507782068305920.ingest.de.sentry.io/4507782074925136',
    environment: ENV,
    // By default, Sentry SDKs normalize any context to a depth of 3. You may want to increase this for sending Redux states
    normalizeDepth: 3,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    sampleRate: 0.5,
    // Tracing
    tracesSampleRate: 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/theseus\.zap\.tech/],
    // Session Replay
    replaysSessionSampleRate: isLocal ? 1 : 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend: (event) => {
      const exception = event.exception?.values && event.exception?.values[0]
      if (
        exception?.value
          .toLowerCase()
          // these errors are not very useful so just ignore them
          .includes('object captured as promise rejection with keys:')
      ) {
        return null
      }

      if (
        exception?.value
          .toLowerCase()
          // this error is user/browser specific, so no need to track it
          .includes(
            'websocket connection failed for host: wss://relay.walletconnect.com',
          )
      ) {
        return null
      }
      return event
    },
  })
}

Big.PE = 50
Big.NE = -50

const root = createRoot(document.getElementById('root'))

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
